import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { DocumentType, PodcastType } from '../../../../types/Podcast';
import { UserFieldsType } from '../../../../types/User';
import Document from '../../../documents/components/Document';
import DocumentHeader from '../../../documents/components/DocumentHeader';
import PodcastDetails from '../../../documents/components/PodcastDetails';
import UnavailablePodcast from '../../../documents/components/UnavailablePodcast';
import PdfViewerComponent from '../../../pdfviewer/components/PdfViewerComponent';
import PodcastDocumentHeaderLoader from '../../../../components/ui/skeleton/PodcastDocumentHeaderLoader';
import TablePodcastSkeletonLoader from '../../../../components/ui/skeleton/TablePodcastSkeletonLoader';
import {
  shouldEnableAutoPlay,
  shouldShowDocumentLink
} from '../../utils/helpers';
import {
  increaseDashboardDocumentsPage,
  resetDashboardDocumentsPage,
  resetDocumentsSearchValue,
  setPlaybackPlaylists,
  updateDocumentsSearchValue
} from '../../../../redux/actions/app-actions';
import {
  setAllDocuments,
  setFullSerialDocuments,
  setPodcastSeasons,
  setSeason
} from '../../../../redux/actions/player-actions';
import { NONE } from '../../../../constants/constants';
import { useDebounce } from 'use-debounce';
import InfiniteScrollWrapper from '../shared/InfiniteScrollWrapper';
import {
  DocumentSortOptionsEnum,
  DocumentSortOrderEnum,
  DocumentSortValueEnum
} from '../../../documents/types/types';
import { changeSortOrder, fetchPodcastDocuments } from '../../utils/utils';
import { FetchDocumentsReasonEnum } from '../../types/enums';
import { scrollToTop } from '../../../../utils/scrollToUtil';
import SeasonPlaybackButton from '../shared/SeasonPlaybackButton';
import RefreshButton from '../../../../components/ui/button/RefreshButton';

const Wrapper = styled.div`
  padding: 10px 0px;
`;

interface IDocumentsTabProps {
  id: string;
  allDocuments: DocumentType[];
  withPodcastId: boolean;
  loader: boolean;
  podcast: PodcastType;
  reload: boolean;
  expand: boolean;
  newNotes: any[];
  season: string;
  podcastType: string;
  seasonCount: number;
  podcastSeasons: string[];
  showPlayButton: boolean;
  userFields: UserFieldsType;
  dashboardDocumentsPage: number;
  allSeasons: string[];
  feedUrl: string;
  fullDocuments: DocumentType[];
  documentsSearchValue: string;
  playerDocument: DocumentType | '';
  playSerial: boolean;
  tabKey: string;
  isLoadingDocuments: boolean;
  isPodcastUnavailable: boolean;
  hasMoreDocuments: boolean;
  reloadDocumentsAndNotes: (
    key: number,
    id: string,
    podcastId: string,
    name: string,
    imageUrl: string,
    feedUrl: string,
    artistName: string,
    webPodcast: string,
    forceReload: boolean,
    authScheme: string,
    enterpriseType: number,
    isOwner: boolean
  ) => void;
  onPlaySummary: (document: DocumentType) => void;
  onPlayDocument: (document: DocumentType) => void;
  onAddSummaryToPlaylist: (document: DocumentType) => void;
  onAdddocumentoPlaylist: (document: DocumentType) => void;
  unsubscribe: () => void;
  setPdfViewerDocumentId: (id: string | number | null) => void;
  setExpand: (expand: boolean) => void;
  setFilterByThumbs: (filter: boolean) => void;
  fetchDocumentsOfPodcast: (
    feedUrl: string,
    forceUpdate: boolean,
    season?: number
  ) => void;
  handleSeasonChange: (season: string) => void;
  playDocuments: () => void;
  neverListenToPodcast: () => DocumentType[];
  increaseDashboardDocumentsPage: () => void;
  resetDocumentsSearchValue: () => void;
  resetDashboardDocumentsPage: () => void;
  setAllDocuments: (documents: DocumentType[]) => void;
  setPodcastSeasons: (seasons: string[]) => void;
  setFullSerialDocuments: (documents: DocumentType[]) => void;
  onShowPlayButton: (showPlayButton: boolean) => void;
  updateDocumentsSearchValue: (searchValue: string) => void;
  setIsLoadingDocuments: (isLoadingDocuments: boolean) => void;
  setIsPodcastUnavailable: (isPodcastUnavailable: boolean) => void;
  setHasMoreDocuments: (hasMoreDocuments: boolean) => void;
}

function DocumentsTab({
  id,
  allDocuments,
  loader,
  podcast,
  reload,
  expand,
  newNotes,
  season,
  podcastType,
  seasonCount,
  podcastSeasons,
  showPlayButton,
  userFields,
  dashboardDocumentsPage,
  playerDocument,
  playSerial,
  tabKey,
  feedUrl,
  fullDocuments,
  isLoadingDocuments,
  isPodcastUnavailable,
  hasMoreDocuments,
  reloadDocumentsAndNotes,
  onPlaySummary,
  onPlayDocument,
  onAddSummaryToPlaylist,
  onAdddocumentoPlaylist,
  unsubscribe,
  setPdfViewerDocumentId,
  setExpand,
  setFilterByThumbs,
  fetchDocumentsOfPodcast,
  handleSeasonChange,
  playDocuments,
  neverListenToPodcast,
  increaseDashboardDocumentsPage,
  resetDocumentsSearchValue,
  resetDashboardDocumentsPage,
  setAllDocuments,
  setPodcastSeasons,
  setFullSerialDocuments,
  onShowPlayButton,
  updateDocumentsSearchValue,
  setIsLoadingDocuments,
  setIsPodcastUnavailable,
  setHasMoreDocuments
}: IDocumentsTabProps) {
  const [openPdfDocument, setOpenPdfDocument] = useState(false);
  const [documentconst, setDocumentConst] = useState('');
  const [document, setDocument] = useState<DocumentType | null>(null);
  const [searchValue, setSearchValue] = useState('');
  const [debouncedSearchValue] = useDebounce(searchValue, 300);
  const [previousPodcastId, setPreviousPodcastId] = useState<string | null>(
    podcast.podcastId
  );
  //   const [hasMoreDocuments, setHasMoreDocuments] = useState(true);
  const [loadingDocuments, setLoadingDocuments] = useState(false);
  const [documentSortOption, setDocumentSortOption] = useState(
    DocumentSortOptionsEnum.DEFAULT
  );
  const [documentSortOrder, setDocumentSortOrder] = useState(
    DocumentSortOrderEnum.DEFAULT
  );
  const [documentSortValue, setDocumentSortValue] = useState(
    DocumentSortValueEnum.DEFAULT
  );
  const [forceReload, setForceReload] = useState(false);

  // Reset state variables when podcast changes
  useEffect(() => {
    if (podcast.podcastId !== previousPodcastId) {
      setPreviousPodcastId(podcast.podcastId);
      setAllDocuments([]);
      setSearchValue('');
      setHasMoreDocuments(true);
      setDocumentSortOption(DocumentSortOptionsEnum.DEFAULT);
      resetDashboardDocumentsPage();
      resetDocumentsSearchValue();
    }
  }, [podcast]);

  // Set season to NONE when podcast type is episodic
  useEffect(() => {
    if (podcastType === 'episodic') {
      setSeason(NONE);
    }
  }, [podcastType]);

  // Save search value to Redux when user stops typing
  useEffect(() => {
    updateDocumentsSearchValue(debouncedSearchValue);
  }, [debouncedSearchValue, updateDocumentsSearchValue]);

  // Handle season change
  useEffect(() => {
    scrollToTop();
    resetDashboardDocumentsPage();
    setHasMoreDocuments(true);
    setIsLoadingDocuments(true);
  }, [season]);

  // Fetch documents when force reload
  useEffect(() => {
    async function forceReloadDocuments() {
      setIsLoadingDocuments(true);
      const reason: FetchDocumentsReasonEnum = FetchDocumentsReasonEnum.FILTER;
      await fetchPodcastDocuments(
        reason,
        allDocuments,
        feedUrl,
        podcast.podcastId,
        debouncedSearchValue,
        0,
        season,
        documentSortOption,
        documentSortValue,
        documentSortOrder,
        playerDocument,
        playSerial,
        fullDocuments,
        setHasMoreDocuments,
        resetDashboardDocumentsPage,
        increaseDashboardDocumentsPage,
        setLoadingDocuments,
        setAllDocuments,
        setFullSerialDocuments,
        onShowPlayButton,
        setPodcastSeasons,
        setIsPodcastUnavailable,
        forceReload
      );
      setIsLoadingDocuments(false);
      setForceReload(false);
    }

    if (podcast.podcastId && feedUrl && tabKey === '3' && forceReload) {
      updateDocumentsSearchValue(searchValue);
      forceReloadDocuments();
    }
  }, [forceReload]);

  // Fetch documents when search value / sorting changes
  useEffect(() => {
    async function fetchSearchedPodcasts() {
      setIsLoadingDocuments(true);
      const reason: FetchDocumentsReasonEnum = FetchDocumentsReasonEnum.FILTER;
      await fetchPodcastDocuments(
        reason,
        allDocuments,
        feedUrl,
        podcast.podcastId,
        debouncedSearchValue,
        0,
        season,
        documentSortOption,
        documentSortValue,
        documentSortOrder,
        playerDocument,
        playSerial,
        fullDocuments,
        setHasMoreDocuments,
        resetDashboardDocumentsPage,
        increaseDashboardDocumentsPage,
        setLoadingDocuments,
        setAllDocuments,
        setFullSerialDocuments,
        onShowPlayButton,
        setPodcastSeasons,
        setIsPodcastUnavailable,
        false
      );
      setIsLoadingDocuments(false);
    }

    if (podcast.podcastId && feedUrl && tabKey === '3') {
      updateDocumentsSearchValue(searchValue);
      fetchSearchedPodcasts();
    }
  }, [debouncedSearchValue, documentSortOption]);

  const goToDocument = (row: DocumentType) => {
    localStorage.removeItem('listOfTags');
    localStorage.removeItem('listOfUsers');
    localStorage.removeItem('pageIndex');

    setPdfViewerDocumentId(row.id);
    setExpand(true);
    setFilterByThumbs(false);
    setOpenPdfDocument(true);
    setDocumentConst(row.documentUrl);
    setDocument(row);
  };

  // Close PDF viewer
  const handleClosePdfViewer = () => {
    setOpenPdfDocument(false);
    setDocumentConst('');
    localStorage.removeItem('pageIndex');
    localStorage.removeItem('listOfTags');
    localStorage.removeItem('listOfUsers');
    setPdfViewerDocumentId(null);
    setExpand(false);
  };

  // Change sort order when user selects a different option
  function handleChangeSortOrder(option: string) {
    changeSortOrder(
      option,
      setDocumentSortOption,
      setDocumentSortValue,
      setDocumentSortOrder
    );
  }

  // Load more documents when user scrolls
  async function loadingMoreDocuments() {
    if (loadingDocuments || !hasMoreDocuments || tabKey !== '3') {
      return;
    }

    setLoadingDocuments(true);
    const reason: FetchDocumentsReasonEnum = FetchDocumentsReasonEnum.LOAD_MORE;
    await fetchPodcastDocuments(
      reason,
      allDocuments,
      feedUrl,
      podcast.podcastId,
      debouncedSearchValue,
      dashboardDocumentsPage,
      season,
      documentSortOption,
      documentSortValue,
      documentSortOrder,
      playerDocument,
      playSerial,
      fullDocuments,
      setHasMoreDocuments,
      resetDashboardDocumentsPage,
      increaseDashboardDocumentsPage,
      setLoadingDocuments,
      setAllDocuments,
      setFullSerialDocuments,
      onShowPlayButton,
      setPodcastSeasons,
      setIsPodcastUnavailable
    );
  }

  if (loader) {
    return (
      <>
        <PodcastDocumentHeaderLoader />
        <TablePodcastSkeletonLoader />
      </>
    );
  }

  return (
    <>
      <div
        className={expand ? 'disappear' : ''}
        style={{ marginLeft: 15, marginRight: 15, marginBottom: 65 }}
      >
        {podcast.podcastId && (
          <Wrapper>
            <PodcastDetails podcast={podcast} onUnsubscribe={unsubscribe} />
            {isPodcastUnavailable && allDocuments.length === 0 && (
              <UnavailablePodcast />
            )}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignContent: 'center'
              }}
            >
              <SeasonPlaybackButton
                showPlayButton={showPlayButton}
                shouldEnableAutoPlay={shouldEnableAutoPlay}
                userFields={userFields}
                playDocuments={playDocuments}
                neverListenToPodcast={neverListenToPodcast}
              />
              <div style={{ marginTop: '20px', marginBottom: '5px' }}>
                <RefreshButton
                  onClick={() => setForceReload(true)}
                  disabled={isLoadingDocuments}
                />
              </div>
            </div>
            <DocumentHeader
              podcastType={podcastType}
              podcastSeasons={podcastSeasons}
              seasonCount={seasonCount}
              season={season}
              onChangeSeason={handleSeasonChange}
              sortOrder={documentSortOption}
              onChangeSortOrder={handleChangeSortOrder}
              searchValue={searchValue}
              onChangeSearchValue={(e: React.ChangeEvent<HTMLInputElement>) =>
                setSearchValue(e.target.value)
              }
              isLoadingDocuments={isLoadingDocuments}
            />
            {isLoadingDocuments && <TablePodcastSkeletonLoader />}
            {!isLoadingDocuments && (
              <>
                <InfiniteScrollWrapper
                  key={tabKey}
                  dataLength={allDocuments.length}
                  next={loadingMoreDocuments}
                  hasMore={hasMoreDocuments}
                  scrollThreshold={0.6}
                >
                  {allDocuments.map((document) => (
                    <Document
                      key={document.uuid} // For issue OSEXIQPCA-2741: Use `uuid` instead of index or timestamp for key
                      document={document}
                      {...(shouldShowDocumentLink(
                        podcast.enterpriseType,
                        podcast.isOwner,
                        document.documentUrl,
                        document.summaryDocument
                      ) && {
                        onGoToDocument: goToDocument
                      })}
                      onPlaySummary={onPlaySummary}
                      onPlayDocument={onPlayDocument}
                      onAddSummaryToPlaylist={onAddSummaryToPlaylist}
                      onAdddocumentoPlaylist={onAdddocumentoPlaylist}
                    />
                  ))}
                </InfiniteScrollWrapper>
              </>
            )}
          </Wrapper>
        )}
      </div>
      {openPdfDocument && (
        // @ts-ignore
        <PdfViewerComponent
          {...{
            newNotes: newNotes || [],
            episode: document,
            document: document?.documentUrl,
            expand: expand,
            handleClickExpand: () => setExpand(!expand),
            handleClosePdfViewer: handleClosePdfViewer
          }}
        />
      )}
    </>
  );
}

const mapStateToProps = (store) => {
  return {
    season: store.player.season,
    dashboardDocumentsPage: store.app.dashboardDocumentsPage,
    allSeasons: store.player.allSeasons,
    podcastSeasons: store.player.podcastSeasons,
    feedUrl: store.player.feedUrl,
    fullDocuments: store.player.fullDocuments,
    documentsSearchValue: store.app.documentsSearchValue,
    playerDocument: store.player.playerDocument
  };
};

const mapDispatchToProps = {
  increaseDashboardDocumentsPage,
  resetDocumentsSearchValue,
  resetDashboardDocumentsPage,
  setAllDocuments,
  setPodcastSeasons,
  setFullSerialDocuments,
  setPlaybackPlaylists,
  updateDocumentsSearchValue
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsTab);
